import React from "react";
import * as RouterDom from "react-router-dom-original";

const { useNavigate, useLocation, useParams, Navigate } = RouterDom;

export * from "react-router-dom-original";

export const useHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const normalizeToAndState = (to, state) => {
    if (to && typeof to === "object" && "state" in to && state === undefined) {
      const { state: stateFromTo, ...toWithoutState } = to;
      return { to: toWithoutState, state: stateFromTo };
    }
    return { to, state };
  };

  return {
    push: (to, state) => {
      const normalized = normalizeToAndState(to, state);
      navigate(normalized.to, { state: normalized.state });
    },
    replace: (to, state) => {
      const normalized = normalizeToAndState(to, state);
      navigate(normalized.to, { replace: true, state: normalized.state });
    },
    go: (delta) => navigate(delta),
    goBack: () => navigate(-1),
    location,
  };
};

export const withRouter = (WrappedComponent) => {
  const WithRouterComponent = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const normalizeToAndState = (to, state) => {
      if (to && typeof to === "object" && "state" in to && state === undefined) {
        const { state: stateFromTo, ...toWithoutState } = to;
        return { to: toWithoutState, state: stateFromTo };
      }
      return { to, state };
    };
    const history = {
      push: (to, state) => {
        const normalized = normalizeToAndState(to, state);
        navigate(normalized.to, { state: normalized.state });
      },
      replace: (to, state) => {
        const normalized = normalizeToAndState(to, state);
        navigate(normalized.to, { replace: true, state: normalized.state });
      },
      go: (delta) => navigate(delta),
      goBack: () => navigate(-1),
      location,
    };

    return (
      <WrappedComponent
        {...props}
        history={history}
        location={location}
        match={{ params }}
        params={params}
        navigate={navigate}
      />
    );
  };

  return WithRouterComponent;
};

export const Redirect = ({ to, push }) => {
  if (typeof to === "string") {
    return <Navigate to={to} replace={!push} />;
  }

  if (to && typeof to === "object") {
    const { pathname, search, hash, state } = to;
    return <Navigate to={{ pathname, search, hash }} state={state} replace={!push} />;
  }

  return null;
};
